var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.32704 6.79021C-0.318059 6.22998 0.0554457 5.16055 0.887262 5.10963L4.99534 4.82107C5.23302 4.80411 5.45366 4.65131 5.55557 4.41364L7.11732 0.594144C7.28707 0.203678 7.64354 0 8.00002 0C8.35649 0 8.71296 0.203678 8.88272 0.594144L10.4445 4.41364C10.5293 4.63435 10.7501 4.78708 11.0047 4.82107L15.1128 5.10963C15.9446 5.16058 16.318 6.23 15.673 6.79021L12.4476 9.42142C12.2609 9.57421 12.176 9.82884 12.2269 10.0835L13.1945 14.0558C13.3303 14.7009 12.855 15.2271 12.2948 15.2271C12.125 15.2271 11.9553 15.1761 11.8025 15.0743L8.28867 12.9184C8.08499 12.7826 7.81333 12.7826 7.60965 12.9184L4.12966 15.0743C3.97687 15.1761 3.79015 15.2271 3.6204 15.2271C3.06017 15.2271 2.55091 14.7009 2.72066 14.0558L3.68824 10.0835C3.73919 9.8458 3.67128 9.59117 3.46753 9.43838L0.32704 6.79021Z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/star.5ef56d236139ab8517a1f1c992252aac.svg";